export enum GDDChartColor {
  alertPredictionColor = "#ffae00",
  sentAlertColor = "#ff0000",
  gddValueColor = "#54b8ff"
}
